import * as React from 'react'

import { TagColor as Color, Tag } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  employeeStatus: Status
}

export type Status = 'active' | 'invited' | 'notInvited' | 'accepted' | 'terminated'

const Indicators = ({ employeeStatus }: Props) => {
  const statusToTagColor: Record<Status, Color> = {
    active: Color.viridian,
    invited: Color.champagne,
    notInvited: Color.grey,
    accepted: Color.purple,
    terminated: Color.radical,
  }
  const type = statusToTagColor[employeeStatus]

  const statusLabel: Record<Status, string> = {
    active: i18n.t('employees.status.active'),
    invited: i18n.t('employees.status.invited'),
    notInvited: i18n.t('employees.status.notInvited'),
    accepted: i18n.t('employees.status.accepted'),
    terminated: i18n.t('employees.status.terminated'),
  }

  return (
    <Tag leftItem="circle" showCircle type={type}>
      {statusLabel[employeeStatus]}
    </Tag>
  )
}

export default observer(Indicators)
